import React, {useContext} from "react";
import {Typography, Space, Button, Row, Col} from "@bezlimit/bezlimit-ui";
import _ from "lodash";
import "./style.scss";
// core
import {LayoutContext, ModalContext} from "../../../core/Contexts";
//images
import iphone1 from "../../../images/iphone1.png";
import iphone2 from "../../../images/iphone2.png";
import iphone3 from "../../../images/iphone3.png";
import android1 from "../../../images/android1.png";
import android2 from "../../../images/android2.png";
import android3 from "../../../images/android3.png";

export default React.memo(function InfoImeiModal() {
    const contextLayout = useContext(LayoutContext);
    const contextModal = useContext(ModalContext);

    const onClick = () => {
        contextModal?.setMaskStyle(undefined);
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
    };

    return (
        <Typography as="div" className="bl-important">
            <Space
                size={_.gte(contextLayout?.width ?? 0, 768) ? 32 : 18}
                direction="vertical"
                align="center"
            >
                <Typography as="div" className="title">
                    {"Как узнать IMEI своего телефона"}
                </Typography>
                {_.gte(contextLayout?.width ?? 0, 768) ? (
                    <Typography as="div" className="sub-title">
                        Быстро: наберите на <span className="orange">клавиатуре телефона </span>{" "}
                        <span className="orange-num">*#06#</span>
                        <span className="black">— IMEI появится на экране.</span>
                    </Typography>
                ) : (
                    <Typography as="div" className="sub-title-mob">
                        Быстрее: наберите на клавиатуре телефона{" "}
                        <span className="black">{"*#06# — IMEI появится \nна экране."}</span>
                        <Typography as="div" className="num-imei-info">
                            <a className={"phone-number"} href={"tel:*#06#"}>
                                <span>*#06#</span> Узнать номер IMEI
                            </a>
                        </Typography>
                    </Typography>
                )}
                <Row gutter={[24, 24]}>
                    <Col xs={24} sm={12}>
                        <Typography as="div" className="info-phone">
                            iPhone
                            <img src={iphone1} alt="" className="phone-img" />
                            <img src={iphone2} alt="" className="phone-img" />
                            <img src={iphone3} alt="" className="phone-img" />
                        </Typography>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Typography as="div" className="info-phone">
                            Android
                            <img src={android1} alt="" className="phone-img" />
                            <img src={android2} alt="" className="phone-img" />
                            <img src={android3} alt="" className="phone-img" />
                        </Typography>
                    </Col>
                </Row>

                <Button type="primary" onClick={onClick}>
                    Закрыть
                </Button>
            </Space>
        </Typography>
    );
});
